import {Box, Typography, useTheme} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';

export default function NotFound() {
	const theme = useTheme();
	const {t} = useTranslation();
	return (
		<>
			<Box className="text-center">
				<Typography
					component={'div'}
					sx={{
						color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
						fontSize: (theme) => theme.typography.fontSize + 5
					}}
					className="p-10 font-bold"
				>
					{t('page_not_found')}
				</Typography>
			</Box>
		</>
	);
}
